import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { useContextHook } from "../../Context/ContextOPen";
import Icon from "../Icons/Icon";

const ContactIcons = ({ index }) => {
  const { swiperIndex } = useContextHook();
  return (
    <div
      className={
        "flex gap-5 py-1 pt-2 " +
        (swiperIndex === index ? " contactIcons " : "")
      }
    >
      <Icon
        href="https://www.tiktok.com/@primpixels?_r=1&_t=ZS-91LUITqi30x"
        Icon={FaTiktok}
      />
      <Icon
        href="https://www.facebook.com/share/17U6soAwi3/"
        Icon={FaFacebookF}
      />
      <Icon href="whatsapp://send?phone=+971504681550" Icon={FaWhatsapp} />
      <Icon
        href="https://www.instagram.com/prim.pixels?igsh=ZTdhN3J3dWJnc2l3"
        Icon={FaInstagram}
      />
    </div>
  );
};

export default ContactIcons;
